import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Uebersicht(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Steuern & Auswertung"
      title="Dashboard & Übersicht – Ihre Finanzen auf einen Blick"
      subtitle="Das Saldify-Dashboard zeigt Ihnen die wichtigsten Kennzahlen in Echtzeit. Umsatz, offene Rechnungen, Steuerlast – alles sofort sichtbar."
      heroImage="/screenshots/app-dashboard.webp"
      heroImageAlt="Dashboard in Saldify: Umsatz, offene Forderungen und Liquidität auf einen Blick"
      features={[
        {
          title: 'Echtzeit-Kennzahlen',
          description: 'Umsatz, Gewinn, offene Posten und Cashflow – aktuell und übersichtlich dargestellt.',
        },
        {
          title: 'Grafische Auswertungen',
          description: 'Diagramme zeigen Ihnen Trends und Entwicklungen auf einen Blick.',
        },
        {
          title: 'Steuervorschau',
          description: 'Sehen Sie, wie viel Umsatzsteuer Sie voraussichtlich ans Finanzamt abführen müssen.',
        },
        {
          title: 'Offene Rechnungen',
          description: 'Behalten Sie überfällige und demnächst fällige Rechnungen im Blick.',
        },
        {
          title: 'Liquiditätsplanung',
          description: 'Sehen Sie, wie sich Ihr Kontostand in den nächsten Wochen entwickeln wird.',
        },
        {
          title: 'Anpassbare Widgets',
          description: 'Stellen Sie sich Ihr Dashboard aus verschiedenen Widgets selbst zusammen.',
        },
      ]}
      sections={[
        {
          title: 'Alle wichtigen Zahlen im Blick',
          description: 'Das Dashboard ist Ihre Schaltzentrale. Hier sehen Sie sofort, wie es um Ihr Unternehmen steht – ohne erst Berichte generieren zu müssen.',
          bullets: [
            'Monatlicher Umsatz und Gewinn',
            'Vergleich zum Vormonat/Vorjahr',
            'Top-Kunden nach Umsatz',
            'Anstehende Zahlungen',
          ],
          imageSide: 'right',
        },
        {
          title: 'Trends erkennen',
          description: 'Grafische Darstellungen zeigen Ihnen, wie sich Ihr Geschäft entwickelt. Erkennen Sie Wachstum, Saisonalität und Optimierungspotenzial.',
          bullets: [
            'Umsatzentwicklung über 12 Monate',
            'Einnahmen vs. Ausgaben',
            'Kundenwachstum',
            'Durchschnittlicher Rechnungsbetrag',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Verschaffen Sie sich den Überblick"
      ctaDescription="Mit dem Saldify-Dashboard haben Sie Ihre Unternehmensfinanzen immer im Griff."
    />
  );
}
